var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 174,
    viewBox: "0 0 172 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_331_739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.197 73.7703C161.67 93.464 157.324 115.817 146.655 130.997C135.985 146.176 116.294 157.424 96.5393 160.908C76.7848 164.391 55.1674 159.525 39.9478 148.9C24.7283 138.275 16.4777 119.065 13.0052 99.3717C9.53264 79.678 12.9935 60.4112 23.6712 45.2199C34.349 30.0287 50.9329 17.894 70.6974 14.409C90.4619 10.924 108.044 19.7287 123.274 30.3518C138.503 40.975 154.727 54.0866 158.197 73.7703Z",
    fill: "#F81958"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.548 79.01C105.281 73.4232 105.313 73.2938 88.0525 67.706C70.7916 62.1182 71.1489 60.7589 53.8869 55.1648C53.4872 55.0398 52.9129 56.0661 52.6045 56.355C52.2971 56.6502 52.1084 56.9962 52.1853 57.4321C58.0906 90.9228 58.8408 90.7905 64.7461 124.281C64.823 124.717 64.0347 126.016 64.4234 126.182C64.6347 126.275 64.9994 124.647 65.218 124.608C65.3953 124.577 65.9358 125.674 66.0857 125.556C80.3944 114.402 80.5223 114.575 94.8311 103.42C109.14 92.266 109.129 92.2418 123.438 81.0874C123.802 80.8018 123.885 79.823 123.801 79.3428C123.721 78.8553 122.988 79.154 122.548 79.01Z",
    fill: "#FAFF29"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_331_739"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 147.521,
    height: 150,
    fill: "white",
    transform: "translate(0 25.6162) rotate(-10)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.6f0d17d4e5e89b5b2efca1117afede66.svg";
export { ForwardRef as ReactComponent };